import React from 'react';
import ReactTable from 'react-table';
import firebase from 'firebase/app';
import 'firebase/database';
import 'firebase/auth';
import ReactFireComponent from '../react-fire-component/react-fire-component';

/** @class AssignedEditors
  * A component for assigning Expo Editors to an Expo.
  */
export default class AssignedEditors extends ReactFireComponent {
  /** @constructor
    * Constructs a new instance of AssignedEditors
    */
  constructor(props) {
    super(props);
    this.state = {
      users: [],
      currentRole: 'n/a'
    }
    this.toggleCheck = this.toggleCheck.bind(this);
  }
  /** @method componentWillMount
    * Binds the component to the firebase database
    * and retreives the current user's role
    */
  componentWillMount(){
    this.bindAsArray(`/users`, 'users');
    const uid = firebase.auth().currentUser.uid;
    firebase.database().ref(`/users/${uid}/role`).on('value', snapshot => {
      this.setState({currentUserRole: snapshot.val()})
    });
  }
  /** @method componentWillUnmount
    * Unbinds the component to the firebase database
    */
  componentWillUnmount() {
    this.unbind('users');
  }
  /** @method toggleCheck
    * Responds to click events on checkboxes by
    * assigning or unassigning Expo Editors.
    * @param {object} event - the inciting event
    */
  toggleCheck(event) {
    const uid = event.target.value;
    const value = event.target.checked ? true : null;
    firebase.database().ref(`${this.props.dataURL}/editors/${uid}`).set(value)
  }
  /** @method render
    * Renders the component.
    */
  render() {
    var users = this.state.users.filter(user => {
      return user.role === "Expo Editor" || user.role === "Admin";
    });
    var columns = [
      {Header: 'Name', accessor: 'name'},
      {Header: 'Email', accessor: 'email'},
    ]
    if(this.state.currentUserRole === "Admin") {
      columns.push({Header: 'Assigned?', accessor: 'id', Cell: (row) => (
        <div className="centered-text">
          <input type="checkbox"
            value={row.value}
            defaultChecked={this.props.assignedEditors[row.value]}
            onClick={this.toggleCheck}
            />
        </div>
      )})
    } else {
      users = users.filter(user => this.props.assignedEditors && this.props.assignedEditors[user.id])
    }
    return (
      <div>
        <label>Assigned Editors</label>
        <ReactTable
          className="-striped"
          data={users}
          columns={columns}
          defaultPageSize={15}
          />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/expo-editor/assigned-editors.js